import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { XMarkIcon } from '@heroicons/react/20/solid';
import { Button } from './button';
import logo from '../images/images.png';

function NavLink({ to, children }) {
  return (
    <Link
      to={to}
      className="inline-block rounded-lg py-1 px-2 text-sm text-slate-700 hover:bg-slate-100 hover:text-slate-900 whitespace-nowrap"
    >
      {children}
    </Link>
  );
}

export function Header() {
  const [showBanner, setShowBanner] = useState(true);
  const [showCalendly, setShowCalendly] = useState(false);

  const dismissBanner = () => {
    setShowBanner(false);
  };

  return (
    <>
      {/* Banner */}
      {showBanner && (
        <div className="flex items-center gap-x-6 bg-blue-600 px-6 py-2.5 sm:px-3.5 sm:before:flex-1">
          <p className="text-sm leading-6 text-white">
            <button type="button" onClick={() => setShowCalendly(true)}>
              <strong className="font-semibold">Want some guidance?</strong>
              <svg viewBox="0 0 2 2" aria-hidden="true" className="mx-2 inline h-0.5 w-0.5 fill-current">
                <circle r={1} cx={1} cy={1} />
              </svg>
              Book a free SBA consultation here&nbsp;<span aria-hidden="true">&rarr;</span>
            </button>
          </p>
          <div className="flex flex-1 justify-end">
            <button
              type="button"
              className="-m-3 p-3 focus-visible:outline-offset-[-4px]"
              onClick={dismissBanner}
            >
              <span className="sr-only">Dismiss</span>
              <XMarkIcon aria-hidden="true" className="h-5 w-5 text-white" />
            </button>
          </div>
        </div>
      )}

      {/* Main header content */}
      <header className="py-10">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <nav className="relative z-50 flex justify-between">
            <div className="flex items-center md:gap-x-16">
              <Link to="/" aria-label="Home">
                <img className="h-12 w-auto" src={logo} alt="Lended" />
              </Link>
              <div className="hidden md:flex md:gap-x-6">
                <NavLink to="/">Home</NavLink>
                <NavLink to="/loan-calculator">Loan Calculator</NavLink>
                <a href="/resources/" className="inline-block rounded-lg py-1 px-2 text-sm text-slate-700 hover:bg-slate-100 hover:text-slate-900 whitespace-nowrap">Insights</a>
                <NavLink to="/broker-signup">Partner Signup</NavLink>
              </div>
            </div>
            <div className="flex items-center gap-x-3 md:gap-x-6">
              <div>
                <NavLink to="/login">
                  <span className="whitespace-nowrap text-sm md:text-base">Sign in</span>
                </NavLink>
              </div>
              <Button type="button" onClick={() => setShowCalendly(true)} color="mainBlue">
                <span className="whitespace-nowrap">
                  Free Consultation
                </span>
              </Button>
            </div>
          </nav>
        </div>
      </header>
      {showCalendly && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-slate-950/70 p-3 backdrop-blur-sm" role="dialog" aria-modal="true" aria-label="Book a free consultation" onMouseDown={(e) => { if (e.target === e.currentTarget) setShowCalendly(false); }}>
          <div className="relative h-[min(860px,94vh)] w-full max-w-3xl overflow-hidden rounded-2xl bg-white shadow-2xl">
            <div className="flex h-14 items-center justify-between border-b border-slate-200 px-5">
              <div className="flex items-center gap-3"><img src={logo} alt="Lended" className="h-8 w-auto" /><span className="text-sm font-semibold text-slate-700">Free SBA consultation</span></div>
              <button type="button" onClick={() => setShowCalendly(false)} className="rounded-lg p-2 text-slate-500 hover:bg-slate-100 hover:text-slate-900" aria-label="Close scheduling window"><XMarkIcon className="h-5 w-5" /></button>
            </div>
            <iframe title="Schedule a free Lended consultation" src="https://calendly.com/isak-lended/lended-sba-financing-intro-call?embed_domain=lended.ai&embed_type=Inline" className="h-[calc(100%-3.5rem)] w-full border-0" />
          </div>
        </div>
      )}
    </>
  );
}
